import React, {
  Fragment,
  useState,
  useEffect,
  useCallback,
  useContext,
} from "react";
import SectionCard from "./SectionCard";
import ButtonComponent from "./Button_v2";
import Modal from 'antd/es/modal';
import {
  Row,
  Col,
  Card,
  Icon,
  Menu,
  Dropdown,
  Form,
  Button,
  Upload,
  Typography,
  Tooltip,
  Tag,
} from "antd";
import LocationIcon from "../../../assets/images/map.png";
import ViewmoreIcon from "../../../assets/images/ViewMore.svg";
import ExpediteChip from "../../../assets/images/Expedite.svg";
import CommercialIcon from "../../../assets/images/Commercial.svg";
import PhoneIcon from "../../../assets/images/PhoneIcon.svg";
import MailIcon from "../../../assets/images/EmailIcon.svg";
import StatusCompleteChip from "../../../assets/images/StatusChip.svg";
import RabbitIcon from "../../../assets/images/Speedy.svg";
import AutographIcon from "../../../assets/images/Autograph.svg";
import EditIcon from "../../../assets/images/EditIcon.svg";
import ContextualModal from "../../common/ContextualModal";
import SignatureImage from "../../../assets/images/Union.svg";
import ModalComponent from "./Modal_v2";
import AddressForm_v2 from "../../components/common/AddressForm_v2";
import { formatFullName, renderAlertMessage, roundToDecimals, checkServiceExistance } from "../../helpers/common";
import {
  formatLtlLocationStatusDisplay,
  isLtlOrganization,
  showLtlOnHandFields,
  ltlStatusChangeModalWidth,
  defaultOutboundDockDatetime,
  ltlOrderWarehouseAtDeliveryDestination,
} from "../../helpers/orders";
import { resolveLegLosCode, withAllStandardLos } from "../../helpers/serviceLevelDerivation";
import { isAppointmentMandatoryOrg } from "../../helpers/appointmentOrgConfig";
import AddressInfo from "../../components/common/AddressInfo";
import DisplayTime from "../../components/common/DisplayTime";
import AppConfig from "../../config/AppConfig";
import moment from "moment";
import Button_v2 from "./Button_v2";
import {
  getLabelDescriptionForLocation,
  getOrderTypeIconForLocation,
  getOrderTypeIconForLocationMap,
  renderNotification,
} from "../../components/orders/OrderTypeIcons";
import LocationBorderIcon from "../../../assets/images/LocationBorder.svg";
import PendingIcon from "../../../assets/images/PendingIcon.svg";
import TreeSelect_v2 from "./TreeSelect_v2";
import Select_v2 from "./Select_v2";
import ReusableDatePicker from "./ReusableDatePicker";
import CustomTimePicker from "./ReusableTimePIcker";
import ReusableInput from "./ReusableInput";
import { alertMessage, getFileIcon, getFileType, isEmpty, randomUUID } from "../../common/Common";
import DeleteIcon from "../../../assets/images/Trash.svg";
import polygonActive from "../../../assets/images/triangle.svg";
import {
  deleteOrder,
  completeLocation,
  revertPickupLocation,
  revertDeliveryLocation,
  fetchLhOrderTrackingDetails,
  deleteOrderPic,
  fetchUpdatedSignerDetails,
  updateOrderDetails_v2,
} from "../../api/OrdersApi";
import TenderEmailModal from "../../components/orders/tenders/TenderEmailModal";
import { AppointmentIcon, ChevronRightIcon, FormIcon, PreplanIcon, RevertIconFilled, StarIcon, TickCircleSvg, TickIcon, TrashIcon } from "../../common/CustomIcon";
import { is } from "core-js/core/object";
import { filter, set } from "lodash";
import userStore from "../../stores/UserStore";
import { UserContext } from "../../context/UserContext";
import PropTypes from "prop-types";
import AddressLocationDetails from "../../components/orders/AddressLocationDetails";
import { OrgContext } from "../../context/OrgContext";
import OrderForm from "../../components/orders/OrderForm";
import OrderSurveyDetails from "../../components/orders/OrderSurveyDetails";
import AddressLocationMap from "../../components/orders/AddressLocationMap";
import masterRateSheet from "../../../assets/images/masterLevelAccessorial.png";
import accLevel from "../../../assets/images/accLevelAccessorial.png";
const { Dragger } = Upload;
const { Paragraph } = Typography;

import I18n from "../../common/I18n";
import { Spin} from '../../common/UIComponents'
import AddressLocationCard from "./AddressLocationCard";
import FilePreviewer from "./FilePreviewer";
import DisableWrapper from "./DisableWrapper";
import BaseModal from "../../components/BaseModal";
import MoreChangeStatusForm from "../../components/orders/MoreChangeStatusForm";
import ChangeStatusForm from "../../components/orders/ChangeStatusForm";

const PICKUP_LINEHAUL_LABELS = ["PLH", "PLHD"];

// PLH/PLHD: the origin warehouse is the terminal immediately after the street pickup.
// Hide Revert Stop once that warehouse tracking status is completed.
const isFirstLinehaulWarehouseLegCompleted = (payload) => {
  const terminals = payload?.data?.terminals || payload?.terminals || payload;
  if (!Array.isArray(terminals)) return false;
  const sorted = [...terminals].sort((a, b) => (a?.sequence_no ?? 0) - (b?.sequence_no ?? 0));
  const pickupIndex = sorted.findIndex((terminal) => String(terminal?.type_of_loc || "").toUpperCase() === "PICKUP");
  const firstWarehouse = sorted[pickupIndex + 1];
  const status = String(firstWarehouse?.tracking_status || "").toUpperCase();
  return status === "COMPLETED" || status === "COMPLETE";
};

function AddressLocationsView({
  location = {},
  currentOrder = {},
  orderTypeConfig = {},
  currentOrg = {},
  config,
  levelOfServices = [],
  standardLosList = [],
  refreshDetails,
  onLinehaulTrackingRefresh,
  updateLocationDetails,
  updateDurationDetails,
  updateReceivedDetails,
  updateDeliverByDetails,
  updateAppointmentDetails,
  updatePickupByDetails,
  updateOnHandDetails,
  updateOutboundDockDetails,
  updateActualDetails,
  selectedWarehouse,
  accountId,
  maximumHeight = "auto",
  // handleRemovePicsInfo = () => {},
  isShipper = false,
  showActions = true,
  currentPreplan,
  setIsModified,
  setOutofPreplan,
  orgSettings,
  // OLOS per-leg lock (Mode A): the order's Service Level effective legs, used
  // to decide whether THIS location has an SL default LOS. undefined/empty in
  // Mode B or when the order has no SL — then the inline LOS edit stays open.
  serviceLevelLegLos = null,
  currentRoute,
  warehouseFilter,
  locObj,
  handleLocationUpdate,
  accessorialDefs,
  haveMultipleLocations,
  // form,
  getAccountComponentDefs,
  currentAccount,
  handleUpdateWhStorage,
  targetWarehouse,
  setTargetWarehouse,
  dtiversData,
  commonLos,
  disableEditLHOrder = false,
  DeleteStop,
  onDeleteDeliveryLocation,
  orgRules,
  configLoading = false,
  ...props
}) {

  const { setFieldsValue } = props.form;
  const [formValues, setFormValues] = useState({
    signed_by: "",
    signature_type: "",
    capture_date: "",
    capture_time: "",
  });
  const roundOffDecimalsForDistance = 2;
  const moveOrderTypes = ["SDR", "MDR", "SDD", "MDD"];
  const emptyText = "Not Available";
  const convertToKg = (lbs) => (lbs * 0.453592).toFixed(2);

  const renderLocationStatus = () => {
    const status = location?.status;
    if (status === "PENDING") {
      return <img src={PendingIcon} alt="PENDING" />;
    }
    if (status === "ASSIGNED") {
      return "ASSIGNED";
    }
    if (status === "COMPLETED") {
      return <img src={StatusCompleteChip} alt="COMPLETED" />;
    }
    const ltlLabel = formatLtlLocationStatusDisplay(status, location?.type_of_loc);
    if (ltlLabel) {
      // Styled chip with the raw LTL code in brackets, e.g. "Arrived at Pickup (ARVP)".
      return (
        <span
          className="ltl-location-status-chip"
          style={{
            display: "inline-block",
            padding: "2px 10px",
            borderRadius: "12px",
            background: "#e5edf6",
            color: "#1f4e79",
            fontWeight: 600,
            fontSize: "12px",
          }}
        >
          {ltlLabel} ({String(status).toUpperCase()})
        </span>
      );
    }
    return emptyText;
  };
  const [openAddressCredsModal, setOpenAddressCredsModal] = useState(false);
  const [titleAddressDetails, setTitleAddressDetails] = useState({
    title: "",
    isAddressForm: false,
    key: "",
  });
  const [modalPosition, setModalPosition] = useState({
    top: 0,
    left: 0,
  });
  const [visible, setVisible] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isUploading, setIsUploading] = useState(false);
  const [isSaving, setIsSaving] = useState(false);
  const [firstWarehouseLegCompleted, setFirstWarehouseLegCompleted] = useState(false);
  const pickupLinehaulOrderId = currentOrder?.id || currentOrder?.customer_order_details?.id;
  const pickupLinehaulLabels = [
    orderTypeConfig?.code,
    currentOrder?.customer_order_details?.order_label,
    currentOrder?.order_label,
  ];
  const isPickupLinehaulOrder = pickupLinehaulLabels.some((label) => PICKUP_LINEHAUL_LABELS.includes(label));

  useEffect(() => {
    const isCompletedPickup = location?.type_of_loc === "PICKUP" && location?.status === "COMPLETED";
    if (!isPickupLinehaulOrder || !isCompletedPickup || !pickupLinehaulOrderId) {
      setFirstWarehouseLegCompleted(false);
      return undefined;
    }
    let cancelled = false;
    fetchLhOrderTrackingDetails(pickupLinehaulOrderId)
      .then((res) => {
        if (cancelled) return;
        setFirstWarehouseLegCompleted(isFirstLinehaulWarehouseLegCompleted(res?.data || res));
      })
      .catch(() => {
        if (!cancelled) setFirstWarehouseLegCompleted(false);
      });
    return () => {
      cancelled = true;
    };
  }, [pickupLinehaulOrderId, isPickupLinehaulOrder, location?.type_of_loc, location?.status]);
  const [isLoading, setIsLoading] = useState(false);
  const [revokeEmailStage, setRevokeEmailStage] = useState(null);
  const [verifyLosFromScreen, setVerifyLosFromScreen] = useState(false);
  const [isAddressFormScreen, setIsAddressFormScreen] = useState(false);
  const [stagedDocs, setStagedDocs] = useState([]);
  const [imagePreview, setImagePreview] = useState("");
  const orgContext = useContext(OrgContext);
  // Mode A: the inline LOS edit is hidden only when (a) the service-level flow
  // is on, (b) the user lacks the "Update Order Tariff" (OLOS) permission, AND
  // (c) THIS leg actually has a Service Level default LOS. A leg with no SL
  // default falls back to the account default and stays editable for everyone —
  // matching the create/edit form. Mode B orgs keep the existing inline edit.
  // checkServiceExistance bypasses for admin/super-admin and users with no RBAC
  // grants (app convention).
  const losEditLockedView =
    orgSettings?.service_level_flow_enabled === "true" &&
    !checkServiceExistance("OLOS") &&
    !!resolveLegLosCode(location, serviceLevelLegLos, levelOfServices);
  // Inline leg-LOS edit shows the account LOS plus every org Standard tariff
  // (grouped by source), so operators can pick any Standard tariff — not just
  // the SL-mapped ones. Same helper the create screen uses.
  // Only union the org Standard rate-sheet tariffs when the service-level flow is on
  // (Mode A) — mirrors create/edit. In Mode B the inline edit shows the account LOS only.
  const losEditOptions = React.useMemo(
    () =>
      orgSettings?.service_level_flow_enabled === "true"
        ? withAllStandardLos(levelOfServices, standardLosList)
        : levelOfServices || [],
    [orgSettings?.service_level_flow_enabled, levelOfServices, standardLosList]
  );
  const [selectedButton, setSelectedButton] = useState(location.type_of_loc);
  const [inProgress,setInprogress] = useState(false);
  const [locked, setLocked] = useState(false); 
  const [isDeleteModalVisible, setDeleteModalVisible] = useState(false);
  const [isStatusChangeModalOpen, setIsStatusChangeModalOpen] = useState(false);
  const [selectedOrderStatus, setSelectedOrderStatus] = useState({});
  const [showReason, setShowReason] = useState(false);

  useEffect(() => {
    if (currentOrder?.customer_order_details?.is_locked !== undefined) {
        setLocked(currentOrder.customer_order_details.is_locked === "true" || currentOrder?.is_deleted_order  ? true : false);
    }
}, [currentOrder?.customer_order_details?.is_locked]);

  useEffect(() => {
    setSelectedButton(location.type_of_loc);
  }, [location.type_of_loc]);

  const modalPositioner = {
    received: {
      top: 10,
      left: 350,
    },
    pickupBy: {
      top: 30,
      left: 350,
    },
    onHand: {
      top: 30,
      left: 350,
    },
    outboundDock: {
      top: 30,
      left: 350,
    },
    deliveryBy: {
      top: 30,
      left: 350,
    },
    receivedCdk: {
      top: 30,
      left: 350,
    },
    pickedUp: {
      top: 30,
      left: 350,
    },
    appointment: {
      top: 70,
      left: 350,
    },
    cdk_actual_times: {
      top: 70,
      left: 350,
    },
    actual: {
      top: 110,
      left: 350,
    },
    duration: {
      top: 10,
      left: 180,
    },
    weight: {
      top: 10,
      left: 180
    },
    levelOfService: {
      top: 10,
      left: 180,
    },
    addressDetails: {
      top: 10,
      left: 500,
    },
    addressLocation:{
      top:300,
      left:500
    },
    locationCode: {
      top: 17,
      left: 470,
    },
    etaDetails: {
      top: 12,
      left: 500,
    },
    surface_area: {
      top: 12,
      left: 180,
    },
    pallets: {
      top: 12,
      left: 180,
    },
    quantity: { 
      top: 12,
      left: 180,
    },
    stop_miles: {
      top: 12,
      left: 180,
    }
  };
  const modalPositionerWhenNoData = {
    received: {
      top: 10,
      left: 150,
    },
    pickupBy: {
      top: 30,
      left: 150,
    },
    onHand: {
      top: 30,
      left: 150,
    },
    outboundDock: {
      top: 30,
      left: 150,
    },
    deliveryBy: {
      top: 30,
      left: 150,
    },
    receivedCdk: {
      top: 30,
      left: 150,
    },
    pickedUp: {
      top: 30,
      left: 150,
    },
    appointment: {
      top: 70,
      left: 150,
    },
    cdk_actual_times: {
      top: 70,
      left: 150,
    },
    actual: {
      top: 110,
      left: 150,
    },
    // duration: {
    //   top: 10,
    //   left: 180,
    // },
    // levelOfService: {
    //   top: 10,
    //   left: 180,
    // },
    // addressDetails: {
    //   top: 10,
    //   left: 500,
    // },
    locationCode: {
      top: 12,
      left: 180,
    },
    surface_area: {
      top: 12,
      left: 180,
    },
    pallets: {
      top: 12,
      left: 180,
    },
    quantity: { 
      top: 12,
      left: 180,
    },
    weight: { 
      top: 12,
      left: 180,
    },
    stop_miles: {
      top: 12,
      left: 180,
    }
  };
  const formsToRender = {
    TimingsScreen: [
      "Received",
      "Pickup By",
      "Delivery By",
      "On Hand at Origin",
      "On Hand at Destination",
      I18n.t("general.on_hand_at_origin"),
      I18n.t("general.on_hand_at_destination"),
      I18n.t("general.outbound_dock_time"),
      "Out for Delivery Time",
      "Received (CDK)",
      "Picked Up",
      I18n.t("general.appointment"),
      "Appointment Date",
      "Service Date",
      "CDKAppointment",
      "Actual",
    ],
    LosandDurationScreen: [`${I18n.t("general.level_of_service")}`, "Duration"],
    LocationCodeScreen: ["Location Code"],
    AddressDetailsScreen: ["Address Details"],
    AddressAddingForm:["Address Location"],
    LocationCodeScreen: ["Location Code"],
    MultiStopParams: ["Weight", "Quantity", "Skids/Pallets", "SurfaceArea"],
    MilesScreen: ["MilesScreen"],
  };
  const ComponentKey = () => {
    const toBeRendered = Object.keys(formsToRender).find((key) =>
      formsToRender[key].includes(titleAddressDetails.title)
    );
    return toBeRendered;
  };

  useEffect(() => {
    if (isModalOpen && signatureObject) {
      setFieldsValue({
        signed_by: signatureObject.sign_by || "",
        signature_type: signatureObject.title_by_relation || "",
        capture_date: moment.utc(signatureObject.captured_at) || null,
        capture_time: moment.utc(signatureObject.captured_at) || null,
      });
      // here handle the delete of the signatureObject.picture_url
      setImagePreview(signatureObject.picture_url);
      // if (signatureObject.picture_url) {
      //   setImagePreview();
      // }
    } else {
      setImagePreview("");
    }
  }, [isModalOpen, signatureObject, setFieldsValue]);

  const openModal = useCallback(() => {
    setIsModalOpen(true);
  }, []);

  const closeModal = useCallback(() => {
    setIsModalOpen(false);
    // Reset all states related to the signature modal
    setFieldsValue({ 
      signed_by: '', 
      signature_type: '', 
      capture_date: null, 
      capture_time: null 
    });
    setStagedDocs([]);
    setImagePreview("");
    setIsLoading(false);
  }, [setFieldsValue]);

  const handleSave = async (e) => {
    setIsLoading(true);
    const { validateFields } = props.form;
    e && e.preventDefault();
    validateFields(async (err, formValues) => {
      // if (!stagedDocs.length && !(signatureObject?.src || signatureObject?.picture_url) && !err) {
      //   renderNotification("Upload documents", 'error');
      // }
      if (!err) { //  && (stagedDocs.length || (signatureObject?.src || signatureObject?.picture_url))
        const formattedDocuments = stagedDocs.map(
          ({ picture_obj, captured_at, ack_id, pic_title, pic_code }) => ({
            captured_at,
            picture_obj,
            ack_id,
            pic_title,
            pic_code,
            picture_type: "signature",
          })
        );
        const itemPictures = {
          refer_id: currentOrder?.id,
          item_pictures: formattedDocuments ? formattedDocuments : [],
        };
        const capture_date = formValues?.capture_date
          ? moment(formValues.capture_date).format("YYYY-MM-DD")
          : "";
        const capture_time = formValues?.capture_time
          ? moment(formValues.capture_time).format("HH:mm")
          : "";

        const payload = {
          refer: "order",
          organization_id: currentOrg?.id || "",
          refer_id: currentOrder.id,
          account_id: currentOrder.customer_order_details.account_id,
          signer_name: formValues.signed_by,
          signer_title: formValues.signature_type,
          captured_at: capture_date
            ? `${capture_date}${capture_time ? ` ${capture_time}` : ""}`
            : "",
          location_id: location?.id ? location.id : "",
          pictures: formattedDocuments.length > 0 ? [itemPictures] : null,
          picture_code: 'signature',
          picture_title: 'Signature',
          image_type: 'signature'
        };
        try {
          setIsUploading(true);
          const response = await fetchUpdatedSignerDetails(payload);

          if (response.success) {
            alertMessage("Documents uploaded successfully");
            setStagedDocs([]);
            setIsModalOpen(false);
            refreshDetails();
          } else {
            console.error("Upload failed: ", response.errors);
            setIsUploading(false);
          }
        } catch (error) {
          console.error("API call failed: ", error.message);
          setIsUploading(false);
        } finally {
          setIsUploading(false);
          // setIsModalVisible(false);
          refreshDetails();
          setIsLoading(false);
        }
        setIsModalOpen(false);
      } else {
        console.error(err);
        setIsLoading(false);
      }
    });
  };

  const handleOnChange = (name, value) => {
    const { setFieldsValue } = props.form;
    setFormValues((prevState) => ({
      ...prevState,
      [name]: value,
    }));
    setFieldsValue({
      [name]: value,
    });
  };
  const updateToggleOption = (element, value,location_id) => {
    if(isShipper) {
      return ;
    }
    const details = _.get(currentOrder, "customer_order_details", false);
    let payload = {
      [element]: value,
      location_id : location_id,
      customer_order_params: {
        customer_order_id: details.id,
        warehouse_id: details.warehouse_id,
        organization_id: currentOrg?.id || "",
        location_id: location?.id || "",
      }, 
    };
    if(element === "type_of_loc"){
      payload.order_location_params =  {
        [element]: value,
        location_id : location_id,
        label_code : element === "type_of_loc" && value === "DELIVERY" ? "D" : "R",
      } 
    }

    const functionToCall = element === "complete_location" ? completeLocation : updateOrderDetails_v2

    if (element === "complete_location") {
      if (props.setIsLoading) {
        props.setIsLoading(true);
      }
      payload = {
        locations: [location?.id],
        organization_id: currentOrg?.id || "",
        screen_from: "order_details"
      }
    }

    setIsSaving(true);
    return functionToCall(currentOrder.id, payload)
    .then((result) => {
      setIsSaving(false);
      if (result?.success) {

        if (result?.response?.message) {
          renderNotification(result?.response?.message || "", "success");
        } else {
          renderNotification(
            `Order ${currentOrder?.customer_order_details?.customer_order_number || ""
          } details have been updated`,
          "success"
        );
        }
        refreshDetails();
        if (element === "complete_location" && onLinehaulTrackingRefresh) {
          onLinehaulTrackingRefresh();
        }
      }
      else {
        renderAlertMessage(result?.errors[0], 5)
      };
    })
    .catch(() => {
      setIsSaving(false);
      renderNotification("Failed to update order details", "error");
    }).finally(() => {
      if (props.setIsLoading) {
        props.setIsLoading(false);
      }
    });
  };

  const getBase64 = (img, ackId) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(img);
      reader.addEventListener("load", () =>
        resolve({ ackId, result: reader.result })
      );
      reader.addEventListener("error", (error) => reject(error));
    });
  };

  const handleChange = async (info, record = {}) => {
    //setInprogress(false);
    if (info.file.status !== "uploading") {
      const ackId = record.ack_id || `${randomUUID()}_n`;
      const picObj = info.file.originFileObj || info.file;
      const picName = info.file.name;

      // Create a new object for the uploaded file
      const podFileObj = {
        picture_obj: picObj,
        captured_at: moment().format(),
        ack_id: ackId,
        converted_img: "",
        pic_title: record.pic_title || "",
        pic_code: record.pic_code || record.pic_title,
        image_type: record.pic_code === "signature" ? "signature" : "normal",
        isNew: true,
        fileType: "",
        fileName: picName,
        src: "",
      };

      // Get the base64 string
      try {
        const data = await getBase64(picObj, ackId);
        const { result } = data;

        // Set converted_img and src to the base64 result
        podFileObj.converted_img = result;
        podFileObj.src = result;

        // Update the stagedDocs state with the new document
        setStagedDocs((prevDocs) => [...prevDocs, podFileObj]);
        setImagePreview(result);
      } catch (error) {
        console.error("Error while converting image:", error);
      }
    }
  };

  const handleDelete = (ackId) => {
    setInprogress(true); // Show spinner immediately
    const data = {
        refer:
            currentOrder?.status === "stop"
                ? "stop"
                : currentOrder?.status === "release"
                ? "release"
                : "order",
        refer_id: currentOrder?.id,
        ack_id: ackId,
        account_id: accountId,
        organization_id: userStore.getStateValue("selectedOrg"),
    };

    deleteOrderPic(data)
        .then((result) => {
            if (result.success) {
                setImagePreview("");
                setStagedDocs([]);
                setIsModalOpen(false);
                alertMessage("Document deleted successfully");
            } else {
                renderAlertMessage(result.errors || "An error occurred");
            }
        })
        .catch((error) => {
            renderAlertMessage([
                error.message || "An error occurred during the deletion process",
            ]);
        })
        .finally(() => {
            setInprogress(false); // Hide spinner after API call completes
            refreshDetails();
        });
  };

  const confirmDelete = () => {
    setDeleteModalVisible(true); // Show the confirmation modal
  };

  const handleDeleteConfirm = (ackId) => {
    setDeleteModalVisible(false); // Close the modal immediately
    handleDelete(ackId); // Proceed with the delete operation
  };

  const onDelete = () => {
    setImagePreview("");
    setStagedDocs([]);
  };

  const renderAdditionalUploader = () => {
    const fileType = getFileType(imagePreview || signatureObject?.src || signatureObject?.picture_url)
    return (<>
    <Spin spinning={inProgress}>
      {imagePreview || signatureObject?.picture_url ? (
        <>
          <div className="signature-container">
            <div className="signature-wrapper" data-testid="signature-view">
              <div className="signature-image">
                {
                  (imagePreview || signatureObject?.src || signatureObject?.picture_url) && (
                    <>
                      {fileType === "image" ? (
                        <img
                          style={{ width: "100%", height: "100%", objectFit: "contain" }}
                          src={
                            imagePreview ? imagePreview : signatureObject?.picture_url
                          }
                          alt="Signature"
                        />
                      ) : (
                        <Icon
                          type={getFileIcon(fileType)}
                          style={{
                            fontSize: "48px",
                            color: "#576EC1",
                            cursor: "pointer",
                            width: "100%",
                            height: "100%",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            opacity: 0.35,
                          }}
                        />
                      )}
                    </>
                  )
                }
              </div>
              <div className="delete-image">
                <img
                  data-testid="delete-signature-icon"
                  onClick={
                    signatureObject?.picture_url
                      ? () => confirmDelete() 
                      : () => onDelete()
                  }
                  src={DeleteIcon}
                  alt=""
                />
              </div>
            </div>
          </div>
        </>
      ) : (
        <Dragger
          className="upload-dragger"
          beforeUpload={(file) =>
            handleChange(
              { file },
              { pic_title: "signature", pic_code: "signature" }
            )
          }
          showUploadList={false}
        >
          <h3 style={{ padding: "8px" }}>Add Signature Image</h3>
          <Button_v2
            data-testid="choose-file-button"
            type="secondary"
            size="small"
            className="outline small-btn"
            text="Choose a File"
          />
        </Dragger>
      )}
      </Spin>
      <Modal
        title="Delete Signature"
        visible={isDeleteModalVisible}
        onOk={() => handleDeleteConfirm(signatureObject?.ack_id)}
        onCancel={() => setDeleteModalVisible(false)}
        okText="Delete"
        cancelText="Cancel"
      >
        <p> Deleting this signature will remove it from the order. This action cannot be undone.</p>
      </Modal>
    </>)
  };
  const renderSignatureForm = () => {
    const { getFieldDecorator } = props.form;
    return (
      <ModalComponent
        visible={isModalOpen}
        onCancel={closeModal}
        title="Signature"
        content={
          <>
            <Row className="signature-card-section" data-testid="signature-modal">
              <Row gutter={[20, 20]} className="table-col">
                <Col
                  span={12}
                  className="time-picker-height input-field-borders"
                >
                  <Form.Item
                    className="custom-form-item"
                    label="Signed By"
                  >
                    {getFieldDecorator("signed_by", {
                      rules: [
                        { required: false, message: "Please Select signed by" },
                      ],
                    })(
                      <ReusableInput
                        data-testid="signed-by-input"
                        name="signed_by"
                        value={formValues.signed_by}
                        onChange={(e) =>
                          handleOnChange("signed_by", e.target.value)
                        }
                      />
                    )}
                  </Form.Item>
                </Col>
                <Col span={12} className="custom-form-item dropdown-field">
                  <Form.Item
                    //className="required-star-right"
                    label="Signer Title"
                  >
                    {getFieldDecorator("signature_type", {
                      rules: [
                        {
                          required: false,
                          message: "Please Select Signer Title",
                        },
                      ],
                    })(
                      <ReusableInput
                        data-testid="title-input" 
                        name="signature_type"
                        value={formValues?.signature_type}
                        onChange={(e) =>
                          handleOnChange("signature_type", e.target.value)
                        }
                      />
                    )}
                  </Form.Item>
                </Col>
              </Row>
              <Row gutter={[20, 20]} className="table-col">
                <Col span={12} className="time-picker-height">
                  <Form.Item
                    label="Capture Date"
                    className="custom-form-item required-star-right"
                  >
                    {getFieldDecorator("capture_date", {
                      rules: [
                        { required: true, message: "Please Select Date" },
                      ],
                    })(
                      <ReusableDatePicker
                        data-testid="capture-date-picker" 
                        placeholder="MM/DD/YYYY"
                        format="MM/DD/YYYY"
                        value={
                          formValues.capture_date
                            ? moment(formValues.capture_date)
                            : null
                        }
                        onChange={(date) =>
                          handleOnChange("capture_date", date)
                        }
                      />
                    )}
                  </Form.Item>
                </Col>
                <Col span={12} className="time-picker-height">
                  <Form.Item
                    label="Capture Time"
                    className="custom-form-item required-star-right"
                  >
                    {getFieldDecorator("capture_time", {
                      rules: [
                        { required: true, message: "Please Select Time" },
                      ],
                    })(
                      <CustomTimePicker
                        data-testid="capture-time-picker"
                        name={"capture_time"}
                        value={formValues.capture_time}
                        onChange={(time) =>
                          handleOnChange("capture_time", time)
                        }
                        format={orgSettings.is_military_time === "true" ? "HH:mm" : "hh:mm A"}
                      />
                    )}
                  </Form.Item>
                </Col>
              </Row>
            </Row>
            <Row>
              <Col span={24}>{renderAdditionalUploader()}</Col>
            </Row>
          </>
        }
        closable={false}
        // onOk={handleSave}
        // okText="OK"
        // cancelText="Cancel"
        width={512}
        height={600}
        centered
        footer={[
          <Button_v2
            data-testid="cancel-signature-button"
            key="cancel"
            text="Cancel"
            className="flat medium-btn"
            onClick={closeModal}
          />,
          <Button_v2
            data-testid="save-signature-button"
            key="confirm"
            text="Save"
            type="primary"
            className="raised medium-btn"
            loading={isLoading}
            onClick={handleSave}
          />,
        ]}
      />
    );
  };
  const handleStatusChange = (value) => {
    setSelectedOrderStatus({ key: value });
  };

  const showStatusChangeModal = (status) => {
    setSelectedOrderStatus(status);
    setIsStatusChangeModalOpen(true);
  };

  const closeStatusChangeModal = () => {
    setIsStatusChangeModalOpen(false);
    setSelectedOrderStatus({});
    setShowReason(false);
  };

  const callbackOfStatusChange = () => {
    closeStatusChangeModal();
    refreshDetails();
  };

  const processErrors = () => {
    // Logic for processing errors if needed
  };

  const renderStatusChangeModal = () => {
    const orderObj = {
      ...currentOrder?.customer_order_details,
      origin: {
        ...currentOrder?.pickup_location_details,
      },
      destination: {
        ...currentOrder?.delivery_location_details,
      },
    };

    return (
      <BaseModal
        title={`Change Status ${currentOrder?.customer_order_details?.customer_order_number
          ? ` of #${currentOrder?.customer_order_details?.customer_order_number}`
          : ""
          }`}
        onCancel={() => closeStatusChangeModal()}
        visible={isStatusChangeModalOpen}
        maskClosable={false}
        keyboard={false}
        width={ltlStatusChangeModalWidth({
          org: currentOrg,
          order: orderObj,
          isBulk: false,
          selectedStatus: selectedOrderStatus?.key,
          isNetmove: currentOrg?.code === I18n.t("account.netmove_code"),
        })}
        bodyStyle={{
          padding: 20,
        }}
      >
        {currentOrg?.code === I18n.t("account.netmove_code") ? (
          <MoreChangeStatusForm
            selectedOrderStatus={selectedOrderStatus}
            matchedkey={true}
            currentStatus={orderObj?.status}
            saveStatus={() => callbackOfStatusChange()}
            orderObject={orderObj}
            closeModal={() => closeStatusChangeModal()}
            orders={[orderObj]}
            processErrors={() => processErrors()}
            hasBulkOrders={false}
            is_military_time={orgSettings.is_military_time === "true"}
            showReason={showReason}
            setShowReason={setShowReason}
            currentOrg={currentOrg}
            organizationSettings={orgSettings}
          />
        ) : (
          <ChangeStatusForm
            organizationSettings={orgSettings}
            selectedOrderStatus={selectedOrderStatus}
            matchedkey={true}
            currentOrg={currentOrg}
            currentStatus={currentOrder?.status}
            saveStatus={() => callbackOfStatusChange()}
            handleUpdateStatus={handleStatusChange}
            orderObject={currentOrder?.customer_order_details}
            closeModal={() => closeStatusChangeModal()}
            orders={[orderObj]}
            processErrors={() => processErrors()}
            hasBulkOrders={false}
            is_military_time={orgSettings.is_military_time === "true"}
            showReason={showReason}
            setShowReason={setShowReason}
            clickFrom="individualLocation"
          />
        )}
      </BaseModal>
    );
  };

  const handleVisibleChange = (flag) => {
    setVisible(flag);
  };

  const handleIconClick = () => {
    setVisible((prevVisible) => !prevVisible);
  };
  const allowedLabels = ["R", "D",];
  const REVERT_PICKUP_ORDER_LABELS = ["T", "RD", "RT", "OBT", "OR", "OD", "PLH", "PLHD"];
  const REVERT_DELIVERY_ORDER_LABELS = ["T", "RD", "RT", "OBT", "OR", "OD"];
  const MsDeleteStop = currentOrder.type_of_order == "MS" && !locked && location.loc_order_sequence > 0 && currentOrder.locations.length > 1 && (config.allow_single_stop_multiple_stop == "true" || location.loc_order_sequence > 1 ) && currentOrder.status != "COMPLETED" && location?.status != "COMPLETED";
  
  // Condition for Delete option: org rule enabled, PENDING status, DELIVERY location, type_of_order is "T"
  const showDeleteDeliveryOption = 
    orgRules?.org_billing_rules?.enable_delete_delivery_leg === "true" &&
    locObj?.status === "PENDING" && 
    location?.type_of_loc === "DELIVERY" && 
    ["T", "B", "E", "H"].includes(currentOrder?.order_label) &&
    onDeleteDeliveryLocation;

  const isImportOrder = currentOrder?.customer_order_details?.is_imported === true || currentOrder?.customer_order_details?.is_imported === "true";
//   const orderLabel =
//     currentOrder?.order_label ||
//     currentOrder?.customer_order_details?.order_label;
  const labelCandidates = [
    orderTypeConfig?.code,
    currentOrder?.customer_order_details?.order_label,
    currentOrder?.order_label,
  ].filter(Boolean);
  const orderLabel = labelCandidates.find((label) => REVERT_PICKUP_ORDER_LABELS.includes(label))
    || labelCandidates[0];
  const typeOfOrder =
    currentOrder?.type_of_order ||
    currentOrder?.customer_order_details?.type_of_order ||
    orderTypeConfig?.type_of_order;

  // Imported orders use Shipper/Consignee instead of Pickup/Delivery for customer legs
  const getImportAwareLocationTitle = (labelCode, typeOfLoc, defaultTitle) => {
    if (!isImportOrder) return defaultTitle;
    if (["R", "SDR", "MDR"].includes(labelCode)) {
      return "Shipper";
    }
    if (["D", "SDD", "MDD"].includes(labelCode)) {
      return "Consignee";
    }
    // MS stops may not have R/D label_code — fall back to type_of_loc only then
    if (!labelCode) {
      if (typeOfLoc === "PICKUP") return "Shipper";
      if (typeOfLoc === "DELIVERY") return "Consignee";
    }
    return defaultTitle;
  };
  const orderLocations = currentOrder?.locations || [];
  const deliveryLocation = orderLocations.find(
    (loc) => loc.type_of_loc === "DELIVERY" && loc.id
  );
  const pickupLocation = orderLocations.find(
    (loc) => loc.type_of_loc === "PICKUP"
  );
  const isPickupLinehaul = labelCandidates.some((label) => PICKUP_LINEHAUL_LABELS.includes(label));
  // PLH/PLHD ignore order status (including ASSIGNED) and delivery status.
  // Linehaul tracking hides the option once the origin warehouse (the terminal
  // right after pickup) is completed. Other labels still require a pending delivery.
  const deliveryAllowsPickupRevert =
    isPickupLinehaul || !deliveryLocation || deliveryLocation.status === "PENDING";
  const canRevertPickup =
    typeOfOrder === "T" &&
    REVERT_PICKUP_ORDER_LABELS.includes(orderLabel) &&
    location?.type_of_loc === "PICKUP" &&
    location?.status === "COMPLETED" &&
    !!pickupLocation &&
    deliveryAllowsPickupRevert &&
    (!isPickupLinehaul || !firstWarehouseLegCompleted);

  // Delivery-leg revert: both legs completed (order COMPLETED) -> revert delivery, order back to
  // ON_HAND. LTL organizations only — the ON_HAND state it reverts into is an LTL concept.
  const canRevertDelivery =
    isLtlOrganization(currentOrg) &&
    currentOrder?.type_of_order === "T" &&
    REVERT_DELIVERY_ORDER_LABELS.includes(orderLabel) &&
    location?.type_of_loc === "DELIVERY" &&
    location?.status === "COMPLETED" &&
    !!pickupLocation &&
    pickupLocation.status === "COMPLETED";

  const handleRevertDeliveryLocation = () => {
    if (isShipper) {
      return;
    }
    const details = _.get(currentOrder, "customer_order_details", false);
    handleVisibleChange(false);
    Modal.confirm({
      title: "Revert Stop",
      content: "Are you sure you want to revert this delivery location?",
      cancelText: "No",
      okText: "Yes",
      onOk: () => {
        props.setIsLoading(true);
        setIsSaving(true);
        return revertDeliveryLocation({
          organization_id: currentOrg?.id || "",
          warehouse_id: details?.warehouse_id || selectedWarehouse || "",
          order_id: details?.id || currentOrder?.id,
          location_id: location?.id,
        })
          .then((result) => {
            setIsSaving(false);
            if (result?.success) {
              renderNotification(
                result?.message ||
                  result?.response?.message ||
                  "Delivery location has been reverted successfully.",
                "success"
              );
              refreshDetails();
            } else {
              const errorMessage =
                result?.errors?.[0] ||
                result?.message ||
                "Failed to revert delivery location";
              renderNotification(errorMessage, "error");
            }
            return result;
          })
          .catch(() => {
            setIsSaving(false);
            renderNotification("Failed to revert delivery location", "error");
          })
          .finally(() => {
            props.setIsLoading(false);
          });
      },
    });
  };

  const handleRevertPickupLocation = () => {
    if (isShipper) {
      return;
    }
    const details = _.get(currentOrder, "customer_order_details", false);
    handleVisibleChange(false);
    Modal.confirm({
      title: "Revert Stop",
      content: "Are you sure you want to revert this pickup location?",
      cancelText: "No",
      okText: "Yes",
      onOk: () => {
        props.setIsLoading(true);
        setIsSaving(true);
        return revertPickupLocation({
          organization_id: currentOrg?.id || "",
          warehouse_id: details?.warehouse_id || selectedWarehouse || "",
          order_id: details?.id || currentOrder?.id,
          location_id: location?.id,
        })
          .then((result) => {
            setIsSaving(false);
            if (result?.success) {
              renderNotification(
                result?.message ||
                  result?.response?.message ||
                  "Pickup location has been reverted successfully.",
                "success"
              );
              refreshDetails();
            } else {
              const errorMessage =
                result?.errors?.[0] ||
                result?.message ||
                "Failed to revert pickup location";
              renderNotification(errorMessage, "error");
            }
            return result;
          })
          .catch(() => {
            setIsSaving(false);
            renderNotification("Failed to revert pickup location", "error");
          })
          .finally(() => {
            props.setIsLoading(false);
          });
      },
    });
  };

  const shouldShowSpecialCheckbox = (type) => {
    const isPLH = orderTypeConfig.code === "PLH";
    const isLHD = orderTypeConfig.code === "LHD";
    const isPLHD = orderTypeConfig.code === "PLHD";
    const isLH = orderTypeConfig.code === "LH" || orderTypeConfig.code === "NLH";
    const isMS = currentOrder?.customer_order_details?.type_of_order == "MS";

    if (isLH || isMS) return false;

    if (type === "pickup") {
      return isPLH || isPLHD || (!isPLH && !isLHD && !isPLHD);
    }
    if (type === "delivery") {
      return isLHD || isPLHD || (!isPLH && !isLHD && !isPLHD);
    }
    return false;
  };
  
  const checkLHOrder = (order) => {
    const isLH = order?.type_of_order == "T" && _.includes(order?.order_label, 'LH');
    return isLH ? order?.order_label === "PLHD" || order?.order_label === "PLH" : true;
  };

  const orderDetails = currentOrder?.customer_order_details || currentOrder;
  const isLtlStorageTransfer =
    orderDetails?.type_of_order === "T" &&
    orderDetails?.wh_storage === true &&
    currentOrg?.is_ltl === true;
  const pickupLegCompleted = (currentOrder?.locations || []).some(
    (loc) => loc.type_of_loc === "PICKUP" && loc.status === "COMPLETED"
  );
  const canManualCompletePickup =
    orgSettings?.allow_completion_of_pickup_location == "true" &&
    location.status != "COMPLETED" &&
    location.type_of_loc == "PICKUP" &&
    orderDetails?.type_of_order == "T" &&
    checkLHOrder(currentOrder);
  // Order WH only (never header selectedWarehouse) — same rule as status change / API.
  const orderWarehouseMatchesDelivery = ltlOrderWarehouseAtDeliveryDestination(
    orderDetails,
    location?.type_of_loc === "DELIVERY" ? location : { warehouse_id: locObj?.warehouse_id },
  );
  const isPlhOrNlhDelivery = ["PLH", "NLH"].includes(orderLabel);
  const canManualCompletePlhNlhDelivery =
    orgSettings?.allow_completion_of_pickup_location == "true" &&
    isPlhOrNlhDelivery &&
    location?.type_of_loc === "DELIVERY" &&
    location?.status !== "COMPLETED" &&
    orderWarehouseMatchesDelivery;
  const canManualCompleteDelivery =
    orgSettings?.allow_completion_of_pickup_location == "true" &&
    location.status != "COMPLETED" &&
    location.type_of_loc == "DELIVERY" &&
    // A PLH/LHD destination is the linehaul warehouse (label DST), not a customer
    // delivery, so it must not offer the manual "Complete Stop" option
    // unless freight has landed (order warehouse == dest warehouse).
    location.label_code != "DST" &&
    isLtlStorageTransfer &&
    orderDetails?.status === "ON_HAND" &&
    pickupLegCompleted &&
    checkLHOrder(currentOrder);
  const canShowCompleteStop =
    canManualCompletePickup || canManualCompleteDelivery || canManualCompletePlhNlhDelivery;

  const isMultiStopOrder = orderTypeConfig?.code === "MS" || currentOrder?.customer_order_details?.type_of_order === "MS" || currentOrder?.type_of_order === "MS" || currentOrder?.customer_order_details?.order_label === "MS";
  const isOrgSpecific = isAppointmentMandatoryOrg(currentOrg?.code);
  const showAppointmentCheckbox = orgSettings?.show_appointment_checkbox_in_create_edit_order_screen === "true" || orgSettings?.show_appointment_checkbox_in_create_edit_order_screen === true;

  const menu = (
    <Menu>
        {!isMultiStopOrder && showAppointmentCheckbox && (
          <Menu.Item
            style={{ display: "flex", alignItems: "center", gap: "10px" }}
            key={"Appointment"}
            disabled={disableEditLHOrder || (isOrgSpecific && location?.appointment?.has_expedite)}
            onClick={() =>
              updateToggleOption(
                "has_appointment",
                !location?.appointment?.has_appointment
              )
            }
          >
            <AppointmentIcon color="#33393D" width="20" height="20" /> {"Appointment"}{" "}
            {location?.appointment?.has_appointment && <TickIcon />}
          </Menu.Item>
        )}
        <Menu.Item
          style={{ display: "flex", alignItems: "center", gap: "10px" }}
          key={"Expedite"}
          disabled={disableEditLHOrder || (isOrgSpecific && location?.appointment?.has_appointment)}
          onClick={() =>
            updateToggleOption(
              "has_expedite",
              !location?.appointment?.has_expedite
            )
          }
        >
          <img src={RabbitIcon} alt="" /> {"Expedite"}{" "}
          {location?.appointment?.has_expedite && <TickIcon />}
        </Menu.Item>
      
      <Menu.Item
        style={{ display: "flex", alignItems: "center", gap: "10px" }}
        key={"Signature"}
        onClick={() =>
          updateToggleOption(
            "is_signature_required",
            !location?.is_signature_required
          )
        }
      >
        <img src={AutographIcon} alt="" /> {"Signature Required"}{" "}
        {location?.is_signature_required && <TickIcon />}
      </Menu.Item>
      {location?.type_of_loc === "PICKUP" && shouldShowSpecialCheckbox("pickup") && (
        <Menu.Item
          style={{ display: "flex", alignItems: "center", gap: "10px" }}
          key={"Pickup Special"}
          onClick={() =>
            updateToggleOption(
              "pickup_special",
              !location?.special,
              location?.id
            )
          }
        >
          <StarIcon /> {"Pickup Special"}{" "}
          {location?.special && <TickIcon />}
        </Menu.Item>
      )}
      {location?.type_of_loc === "DELIVERY" && shouldShowSpecialCheckbox("delivery") && (
        <Menu.Item
          style={{ display: "flex", alignItems: "center", gap: "10px" }}
          key={"Delivery Special"}
          onClick={() =>
            updateToggleOption(
              "delivery_special",
              !location?.special,
              location?.id
            )
          }
        >
          <StarIcon /> {"Delivery Special"}{" "}
          {location?.special && <TickIcon />}
        </Menu.Item>
      )}
      {allowedLabels.includes(location.label_code) && (
        <Menu.Item
        style={{ display: "flex", alignItems: "center", gap: "5px" }}
        key={"Form"}
        onClick={() =>
          updateToggleOption(
            "is_form_required",
            !location?.is_form_required
          )
        }
      >
        <FormIcon  />{"Form Required"}{" "}
        {location?.is_form_required && <TickIcon />}
       </Menu.Item>
      )}

      {showDeleteDeliveryOption && (
        <Menu.Item
          className="delete"
          style={{ display: "flex", alignItems: "center", gap: "10px" }}
          key={"delete-delivery"}
          onClick={() => {
            setVisible(false);
            Modal.confirm({
              title: 'Delete Delivery Location',
              icon: <TrashIcon styling={{ width: '22px', height: '22px' }} color={'#D23B71'} />,
              content: 'Are you sure you want to delete this delivery location?',
              cancelText: "No",
              okText: "Yes",
              onOk: () => {
                if (onDeleteDeliveryLocation) {
                  onDeleteDeliveryLocation(location);
                }
              },
              onCancel: () => { },
            });
          }}
        >
          <TrashIcon styling={{ width: '22px', height: '22px' }} />{"Delete"}
       </Menu.Item>
      )}
      {canShowCompleteStop &&
        <Menu.Item
        style={{ display: "flex", alignItems: "center", gap: "10px" }}
          key={"complete_location"}
          onClick={() => {
            handleVisibleChange(false)
            updateToggleOption(
              "complete_location",
              !location?.complete_location
            )
          }
          }
      >
         <TickCircleSvg color="#33393D" width="24" height="24"/>{I18n.t("general.complete_stop")}{" "}
      </Menu.Item>}

      {checkServiceExistance("OPRL") && canRevertPickup &&(
        <Menu.Item
          style={{ display: "flex", alignItems: "center", gap: "10px" }}
          key={"revert_location"}
          onClick={handleRevertPickupLocation}
        >
          <RevertIconFilled color="#33393D" width="24" height="24" />
          {"Revert Stop"}
        </Menu.Item>
      )}

      {checkServiceExistance("OPRL") && canRevertDelivery &&(
        <Menu.Item
          style={{ display: "flex", alignItems: "center", gap: "10px" }}
          key={"revert_delivery_location"}
          onClick={handleRevertDeliveryLocation}
        >
          <RevertIconFilled color="#33393D" width="24" height="24" />
          {"Revert Stop"}
        </Menu.Item>
      )}

      {MsDeleteStop && (
        <Menu.Item
          style={{ display: "flex", alignItems: "center", gap: "10px" }}
          key={"trash"}
          onClick={() =>
            Modal.confirm({
              width: 500,
              content: "Are you sure you want to delete this location?",
              cancelText: "No",
              okText: "Yes",
              onOk: () => {
                DeleteStop(location.id)
              },
              onCancel: () => { },
            })}
        >
          <TrashIcon />{"Delete Stop"}{" "}
        </Menu.Item>
      )}
    </Menu>
  );
  const extranodeFunc = () => {
    const isCrossDock = location?.label_code === "CDK" || orderTypeConfig.code === 'CDK' || orderTypeConfig.code === 'WO';
    const mileage=currentOrder?.customer_order_details?.mileage;
    const stopMiles=location?.stop_miles;

    let checker;
    if (["R", "D", "LH", "M", "MS"].includes(currentOrder?.type_of_order)) {
      checker =
      mileage !== "" && mileage != null && mileage !== location?.distance
          ? "mileage"
          : "";
    } else {
      checker =
      stopMiles !== "" && stopMiles != null && stopMiles !== location?.distance
        ? "stop_miles"
        : "";    
    }

    const checkerDisplay =
      checker == "stop_miles" && !isEmpty(stopMiles)
        ? `(User Specified Miles: ${stopMiles != "NA" ? roundToDecimals(stopMiles, roundOffDecimalsForDistance) : stopMiles})`
        : checker == "mileage" && !isEmpty(mileage)
          ? `(User Specified Miles: ${mileage != "NA" ? roundToDecimals(mileage, roundOffDecimalsForDistance) : mileage})`
          : "";

    return (
      !isCrossDock ? <>
        <Row
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            gap: "10px",
          }}
        >
          <Col>
            {location?.appointment?.has_expedite && (
              <img src={ExpediteChip} alt="" />
            )}
          </Col>
          <Col className="header-text-locations">
            {`${location?.distance} mi ${checkerDisplay}`}
          </Col>
          {!locked && (
            <Col className="view-more-icon">
            <img
              data-testid="view-options"
              style={{ cursor: "pointer" }}
              src={ViewmoreIcon}
              onClick={handleIconClick}
              alt=""
              />
          </Col>
            )}
        </Row>
        <div className="extra-node-function">
          <Dropdown
            placement="bottomLeft"
            overlay={menu}
            trigger={["click"]}
            visible={visible}
            onVisibleChange={handleVisibleChange}
          >
            <a
              className="ant-dropdown-link"
              onClick={(e) => {
                e.preventDefault();
              }}
            />
          </Dropdown>
        </div>
      </> : null 
    );
  };

  const renderAddressCredsModal = () => {
    return (
      <ContextualModal
        openModal={openAddressCredsModal}
        onClose={() => {
          setOpenAddressCredsModal(false);
          setTitleAddressDetails({
            title: "",
            isAddressForm: false,
            key: "",
            prevFormVlaues: {}
          });
          setVerifyLosFromScreen(false);
          setIsAddressFormScreen(false);
          setModalPosition({
            top: 0,
            left: 0
          });
        }}
        setVerifyLosFromScreen={setVerifyLosFromScreen}
        cdkAppointment={cdkAppointment}
        labelTitle={titleAddressDetails.title}
        isAddressForm={titleAddressDetails.isAddressForm}
        modalPosition={modalPosition}
        keyToBeUsed={titleAddressDetails.key}
        formsToRender={ComponentKey()}
        verifyLosFromScreen={verifyLosFromScreen}
        currentOrder={currentOrder}
        location={location}
        isAddressFormScreen={isAddressFormScreen}
        currentOrg={currentOrg}
        levelOfServices={losEditOptions}
        prevFormVlaues={titleAddressDetails.prevFormVlaues}
        refreshDetails={refreshDetails}
        updateLocationDetails={updateLocationDetails}
        updateDurationDetails={updateDurationDetails}
        updateReceivedDetails={updateReceivedDetails}
        updateDeliverByDetails={updateDeliverByDetails}
        updateAppointmentDetails={updateAppointmentDetails}
        updatePickupByDetails={updatePickupByDetails}
        updateOnHandDetails={updateOnHandDetails}
        updateOutboundDockDetails={updateOutboundDockDetails}
        updateActualDetails={updateActualDetails}
        setOpenAddressCredsModal={setOpenAddressCredsModal}
        selectedWarehouse={selectedWarehouse ? selectedWarehouse : ""}
        config={config}
        currentPreplan={currentPreplan}
        setOutofPreplan={setOutofPreplan}
        setIsModified={setIsModified}
        isMilitaryTime={orgSettings.is_military_time == "true"}
        timeFormat={orgSettings.is_military_time == "true" ? "HH:mm" : "hh:mm A"}
        currentRoute={currentRoute}
        warehouseFilter={warehouseFilter}
        orderTypeConfig={orderTypeConfig}
        locObj={locObj}
        handleLocationUpdate={handleLocationUpdate}
        accessorialDefs={accessorialDefs}
        haveMultipleLocations={haveMultipleLocations}
        form={props.form}
        getAccountComponentDefs={getAccountComponentDefs}
        currentAccount={currentAccount || {}}
        handleUpdateWhStorage={handleUpdateWhStorage}
        targetWarehouse={targetWarehouse}
        setTargetWarehouse={setTargetWarehouse}
        orgContext={orgContext}
        dtiversData={dtiversData}
      />
    );
  };

  const setPropsData = (key) => {
    switch (key) {
      case "received":
        const received_at =
          currentOrder?.customer_order_details?.received_at || null;
        return {
          start_date: received_at ? moment.utc(received_at) : null,
          start_time: received_at ? moment.utc(received_at) : null,
        };
      case "pickupBy":
        const pickup_by =
          currentOrder?.customer_order_details?.pickup_by || null;
        return {
          start_date: pickup_by ? moment.utc(pickup_by) : null,
          start_time: pickup_by ? moment.utc(pickup_by) : null,
        };
      case "onHand":
        const onHandAt = location?.on_hand_datetime || null;
        return {
          start_date: onHandAt ? moment.utc(onHandAt) : null,
          start_time: onHandAt ? moment.utc(onHandAt) : null,
        };
      case "outboundDock": {
        const outboundDockAt = location?.outbound_dock_datetime || null;
        let dockMoment = outboundDockAt ? moment.utc(outboundDockAt) : null;
        if (!dockMoment?.isValid?.()) {
          const defaulted = defaultOutboundDockDatetime({
            ...currentOrder,
            destination: location,
            locations: currentOrder?.locations,
          });
          dockMoment = defaulted?.isValid?.() ? defaulted : null;
        }
        return {
          start_date: dockMoment,
          start_time: dockMoment,
        };
      }
      case "deliveryBy":
        const delivery_by =
          currentOrder?.customer_order_details?.delivery_by || null;
        return {
          start_date: delivery_by ? moment.utc(delivery_by) : null,
          start_time: delivery_by ? moment.utc(delivery_by) : null,
        };
      case "receivedCdk":
        const cdk_actual_times = location?.actual_start_datetime || null;
        return {
          start_date: cdk_actual_times ? moment.utc(cdk_actual_times) : null,
          start_time: cdk_actual_times ? moment.utc(cdk_actual_times) : null,
        };
       case "pickedUp" :
        const pickedUp = location?.actual_start_datetime || null;
        return {
          start_date: pickedUp ? moment.utc(pickedUp) : null,
          start_time: pickedUp ? moment.utc(pickedUp) : null,
        };
      case "appointment":
        const appointment = location?.appointment || null;
        return {
          appt_date: appointment?.appt_date ? moment.utc(appointment.appt_date) : null,
          start_time: appointment?.start_time || null,
          end_time: appointment?.end_time || null,
          slot: _.get(appointment, "slots[0]", "") || '',
          has_appointment: appointment?.has_appointment || false,
        };
      case "addressDetails":
        return {
          company_name: location.company_name,
          customer_email: location.email,
          customer_address_line_1: location?.address?.address_line1 || "",
          customer_address_line_2: location?.address?.address_line2 || "",
          customer_city: location?.address?.city || "",
          customer_state: location?.address?.state || "",
          customer_country: location?.address?.country || "",
          customer_zipcode: location?.address?.zipcode || "",
          address_type: location?.address_type || "COMMERCIAL",
          operational_use: location?.operational_use || location?.address?.operational_use || "FINAL_MILE",
          customer_phone_one: location.phone,
          customer_phone_two: location.phone_2,
          customer_first_name: location.first_name,
          l_type:
            currentOrder?.customer_order_details?.order_label == "LH"|| currentOrder?.customer_order_details?.order_label == "NLH"
              ? "WH"
              : "CS",
          label_code: location.label_code,
          type_of_loc: location.type_of_loc,
        };
      case "addressLocation":
        return{
          company_name: location.company_name,
          customer_email: location.email,
          customer_address_line_1: location?.address?.address_line1 || "",
          customer_address_line_2: location?.address?.address_line2 || "",
          customer_city: location?.address?.city || "",
          customer_state: location?.address?.state || "",
          customer_country: location?.address?.country || "",
          customer_zipcode: location?.address?.zipcode || "",
          address_type: location?.address?.address_type || "COMMERCIAL",
          operational_use: location?.operational_use || location?.address?.operational_use || "FINAL_MILE",
          customer_phone_one: location.phone,
          customer_phone_two: location.phone_2,
          customer_first_name: location.first_name,
          l_type:
            currentOrder?.customer_order_details?.order_label == "LH" || currentOrder?.customer_order_details?.order_label == "NLH"
              ? "WH"
              : "CS",
          label_code: location.label_code,
          type_of_loc: location.type_of_loc,
        };
      case "duration":
        return { service_duration: location.service_duration };
      case "levelOfService": {
        // Seed los_id + rate_sheet_id from the current selection so the dropdown
        // highlights the exact tariff (id-keyed) and an unchanged save re-sends the
        // same los_code + rate_sheet_id contract. Matched against the unioned
        // options (account + Standard) by id first, then code.
        const cur =
          (location.los_id && losEditOptions.find((o) => o.id === location.los_id)) ||
          losEditOptions.find((o) => o.code === location.los_code);
        return {
          los_code: location.los_code,
          los_id: cur?.id || location.los_id || "",
          rate_sheet_id: cur?.rate_sheet_id || "",
        };
      }
      case "locationCode":
        return { acc_loc_code: location.acc_loc_code };
      case "actual":
        const actual_start_datetime = location?.actual_start_datetime || null;
        const actual_end_datetime = location?.actual_end_datetime || null;
        return {
          start_date: actual_start_datetime
            ? moment.utc(actual_start_datetime)
            : null,
          start_time: actual_start_datetime
            ? moment.utc(actual_start_datetime)
            : null,
          end_date: actual_end_datetime
            ? moment.utc(actual_end_datetime)
            : null,
          end_time: actual_end_datetime
            ? moment.utc(actual_end_datetime)
            : null,
        };
      case "stop_miles":
        return {
          stop_miles: location.stop_miles,
          distance: location.distance
        };
      case "pallets":
      case "surface_area":
      case "weight":
      case "quantity": return { [key]: location?.[key] };
      default:
        return "params";
    }
  };

  const renderTitleAddressDetails = (key, title, isAddressForm = false) => {
    const prevFormVlaues = { [key]: setPropsData(key) };
    setOpenAddressCredsModal(true);
    setTitleAddressDetails({
      title: title,
      isAddressForm: isAddressForm,
      key,
      prevFormVlaues,
    });
  };

  const positionEditModal = (event, key) => {
    const elementPosition = event.target.getBoundingClientRect();
    setModalPosition({
      top: elementPosition.top + window.scrollY - modalPositioner[key].top,
      left: elementPosition.left + window.scrollX - modalPositioner[key].left,
    });
  };

  const positionEditModalWhenNoData = (event, key) => {
    const elementPosition = event.target.getBoundingClientRect();
    setModalPosition({
      top:
        elementPosition.top +
        window.scrollY -
        modalPositionerWhenNoData[key].top,
      left:
        elementPosition.left +
        window.scrollX -
        modalPositionerWhenNoData[key].left,
    });
  };

 /* const handleLocTypeChange = (buttonType,location_id) => {
    if (buttonType !== selectedButton) {
      setSelectedButton(buttonType);
      updateToggleOption("type_of_loc", buttonType,location_id);
    }
  };*/

  const handleLocTypeChange = (buttonType, location_id) => {
    if (buttonType !== selectedButton) {
      updateToggleOption("type_of_loc", buttonType, location_id)
        .then((result) => {
          if (result?.success) {
            setSelectedButton(buttonType);
          } else if (!location_id) {
            renderNotification(result?.errors?.[0], "error");
          }
        })
        .catch(() => {
          if (!location_id) {
            renderNotification("Failed to update location type", "error");
          }
        });
    }
  };

  const renderTimeRow = (label, key, dateTimeString) => {
    const hasDateTime = !!dateTimeString;
    const isLtlEditableDatetime = ["onHand", "outboundDock"].includes(key);
    const tzShortName = ['pickupBy','deliveryBy', 'received'].includes(key) ? 
      currentOrder?.customer_order_details?.tz_short_name : location?.time_zone_short_name;
    return (
      <Row
        type="flex"
        data-testid={`${label.replace(/\s+/g, '')}-view`}
        className={`key-value-text ${hasDateTime ? "has-date" : ""}${
          isLtlEditableDatetime ? " ltl-editable-datetime-row" : ""
        }`}
        // On-hand / out-for-delivery stay editable when the LH card is read-only.
        style={
          isLtlEditableDatetime ? { pointerEvents: "auto", cursor: "default" } : undefined
        }
      >
        <Col xs={24} xl={6} className="key-text">
          {label}
        </Col>
        {dateTimeString ? (
          isLtlEditableDatetime ? (
            <Col xs={16} xl={16} className="value-Text">
              {moment.utc(dateTimeString).format(AppConfig.report_date_format)}{" "}
              <DisplayTime
                displayWithDate={false}
                dateTimeString={dateTimeString}
                isUTC={true}
                timeZoneId={location?.timeZoneId || location?.time_zone_id}
              />{" "}
              {tzShortName}
            </Col>
          ) : (
            <>
              <Col xs={10} xl={8} className="value-Text">
                {dateTimeString
                  ? moment.utc(dateTimeString).format(AppConfig.report_date_format)
                  : emptyText}
              </Col>
              <Col xs={10} xl={8} className="value-Text">
                {dateTimeString ? (
                  <DisplayTime
                    displayWithDate={false}
                    dateTimeString={dateTimeString}
                  />
                ) : (
                  emptyText
                )}{" "}
                {tzShortName}{" "}
              </Col>
            </>
          )
        ) : (
          <>
            {key === "etaDetails" ? (
              <Col span={16} className="value-Text">
                {emptyText}
              </Col>
            ) : (
              showActions && (
                <Col span={16} className="value-Text">
                  <Button_v2
                    data-testid={`add-${label.replace(/\s+/g, '')}-button`}
                    text={"Add " + label}
                    className="medium-btn flat"
                    onClick={(event) => {
                      renderTitleAddressDetails(key, label);
                      positionEditModalWhenNoData(event, key);
                    }}
                  />
                </Col>
              )
            )}
          </>
        )}
        {!["etaDetails"].includes(key) && showActions && location?.id && (
          <Col span={2} className="edit-icon">
            <img
              data-testid={`${label.replace(/\s+/g, '')}-edit`}
              src={EditIcon}
              alt=""
              onClick={(event) => {
                renderTitleAddressDetails(key, label);
                positionEditModal(event, key);
              }}
            />
          </Col>
        )}
      </Row>
    );
  };

  const generateOrderCombinedCode = () => {
    const resolvedCode = orderTypeConfig?.extraCode || orderTypeConfig.code;
    return `${resolvedCode}-${location?.label_code || ""}`;
  };

  const getLabelForAppointments = () => {
    if ((orderTypeConfig.code || "").includes("CDK") || (orderTypeConfig.code || "").includes("WO")) {
      const labelCode = generateOrderCombinedCode();
      if (labelCode == "PCDK-CDK" || labelCode == "CDK-R" || labelCode == "WO-R") {
        return "Pick by";
      } else if (labelCode == "CDKD-CDK" || labelCode == "CDK-DRPF" || labelCode == "WO-DRPF") {
        return "Drop by";
      }
    }
    if (["MWE", "FET"].includes(currentOrg?.code)) {
      if (location?.appointment?.has_appointment) {
        return "Appointment Date";
      } else if (location?.appointment?.has_expedite) {
        return "Appointment Date";
      } else {
        return "Service Date";
      }
    }
    return I18n.t("general.appointment");
  };
  const sectionTitleFun = () => {
    let currentSeq = location?.loc_order_sequence;

    const checkSingleStopMultipleStop = config?.allow_single_stop_multiple_stop === "true" && currentOrder?.type_of_order == "MS" && locObj?.loc_order_sequence === 0;

    if (checkSingleStopMultipleStop) {
      if (currentOrder?.locations?.length > 1) {
        currentSeq = 0;
      } else {
        currentSeq = 1;
      }
    }

    const handleRemoveAgent = (id, typeOfLoc, loc) => {
      const agent = (loc || locObj)?.tender_agent_details || {};
      // A real AgentTenderOrder doc stamps tender_number/batch_id; legacy is_tender agents
      // only get a fabricated leg_id server-side (customer_order_details_service:559), so
      // leg_id presence alone can't distinguish them — key off tender_number/batch_id.
      const hasRealTender = !!(agent.tender_number || agent.batch_id);
      if (orgSettings?.agent_load_tender === "true" && hasRealTender) {
        const agentId = agent.agent_id || (loc || locObj)?.fleet_agent_id;
        if (!agentId) {
          renderNotification("No agent found to revoke for this leg.", "error");
          return;
        }
        const legId =
          agent.leg_id ||
          (typeOfLoc === "DELIVERY" ? "del_1" : typeOfLoc === "PICKUP" ? "pu_1" : null);
        if (!legId) {
          // No resolvable leg → never send leg_ids: [] (server treats blank as revoke-all).
          renderNotification("No agent found to revoke for this leg.", "error");
          return;
        }
        const tnd = agent.tender_number || "";
        const tndLabel = tnd || "tendered orders";
        const emails = Array.isArray(agent.email)
          ? agent.email.filter(Boolean)
          : agent.email
          ? [agent.email]
          : [];
        setRevokeEmailStage({
          revokeOrders: [{ order_id: id, leg_ids: [legId] }],
          agentEmails: [
            {
              agent_id: agentId,
              agent_name: agent.agent_name || agent.agent_code || "Agent",
              tender_number: tnd,
              email: emails,
              subject: `Tender Cancelled – ${tndLabel}`,
              description: `This is to inform you that the tender ${tndLabel} has been canceled. Please disregard the manifest and BOL previously sent.\n\nWe apologize for any inconvenience.`,
              attachments: [],
            },
          ],
        });
        return;
      }

      Modal.confirm({
        width: 500,
        content: "Are you sure you want to revoke this agent order?",
        cancelText: "No",
        okText: "Yes",
        onOk: () => {
          setIsSaving(true);
          let delete_tender_order = false;
          let delete_order = false;
          let delete_agent_order = true;
          deleteOrder(id, delete_tender_order, delete_order, delete_agent_order, typeOfLoc).then(() => {
              renderNotification("Agent removed successfully", "success");
              refreshDetails();
            })
            .catch(() => {
              renderNotification("Failed to remove agent", "error");
            })
            .finally(() => {
              setIsSaving(false);
            })
        },
      })
    }

    const [hovered, setHovered] = useState(false);

    return (
      <Spin spinning={isSaving}>
      <Row type="flex" gutter={10} align="middle">
        {currentOrder?.type_of_order !== "MS" ? (
          <Col>
            <h3 className="location_heading">
              {getImportAwareLocationTitle(
                locObj?.label_code,
                locObj?.type_of_loc || location?.type_of_loc,
                getLabelDescriptionForLocation(locObj?.label_code, (orderTypeConfig?.extraCode || orderTypeConfig?.code))
              )}{locObj?.has_tender == "true" &&    
            <Tag
                color="blue"
                onMouseEnter={() => setHovered(true)}
                onMouseLeave={() => setHovered(false)}
                style={{
                  marginLeft: "0.5rem",
                  cursor: "pointer",
                  fontWeight: 500,
                  display: "inline-flex",
                  alignItems: "center",
                  overflow: "hidden",
                  transition: "all 0.25s ease",
                  paddingRight: hovered ? "8px" : "7px"
                }}
              >
                <span>Agent</span>

              { !locked && !["COMPLETED", "CLOSED", "ARCHIVED"].includes(currentOrder.status) && (locObj?.status !== "COMPLETED") && <span
                  style={{
                    display: "inline-flex",
                    alignItems: "center",
                    justifyContent: "center",
                    width: hovered ? "16px" : "0px",
                    opacity: hovered ? 1 : 0,
                    transition: "all 0.25s ease",
                  }}
                >
                  <Icon
                    type="close"
                    onClick={(e) => {
                      e.stopPropagation();
                      handleRemoveAgent(currentOrder?.id, locObj?.type_of_loc, locObj);
                    }}
                    style={{
                      fontSize: "12px",
                      cursor: "pointer"
                    }}
                  />
                </span>}
              </Tag>  
              }
              {(locObj?.label_code === "DST" || locObj?.label_code === "ORN") && (orderTypeConfig?.code === "PLH" || orderTypeConfig?.code === "LHD") && ` (${I18n.t('general.warehouse')})`}
            </h3>
          </Col>
        ) : location?.location_id ? ( 
          <div className="multiStopToggleButton" style={{ marginLeft: '6px' }}>
            <div
              onClick={() =>
                currentSeq === 0 ? undefined : handleLocTypeChange("PICKUP", location?.location_id)
              }
              className={`orderListIconContainer ${
                selectedButton === "PICKUP" ? "buttonActive" : "buttonDefaultColor"
              }`}
                style={{ cursor: currentSeq === 0 ? 'not-allowed' : 'pointer' }}
            >
              {isImportOrder ? "Shipper" : "Pickup"}
              {selectedButton === "PICKUP" && (
                <img className="polygon" src={polygonActive} alt="^" />
              )}
            </div>
            <div
              onClick={() =>
                currentSeq === 0 ? undefined : handleLocTypeChange("DELIVERY", location?.location_id)
              }
              className={`driverMapIconContainer ${
                selectedButton === "DELIVERY" ? "buttonActive" : "buttonDefaultColor"
              }`}
                style={{ cursor: currentSeq === 0 ? 'not-allowed' : 'pointer' }}
              >
              {isImportOrder ? "Consignee" : "Delivery"}
              {selectedButton === "DELIVERY" && (
                <img className="polygon" src={polygonActive} alt="^" />
              )}
            </div>
          </div>
        ) : null} 
      </Row>
      </Spin>
    );
  };
  
  
  const title = sectionTitleFun();
  const titleEmptyCard = getImportAwareLocationTitle(
    location?.label_code,
    location?.type_of_loc,
    getLabelDescriptionForLocation(location?.label_code, orderTypeConfig?.extraCode || orderTypeConfig?.code)
  );
  const received_at = currentOrder?.customer_order_details?.received_at || null;
  const delivery_by = currentOrder?.customer_order_details?.delivery_by || null;
  const pickup_by = currentOrder?.customer_order_details?.pickup_by || null;
  const cdk_actual_times = location?.actual_start_datetime || null;
  const actual_at =
    location?.actual_end_datetime || location?.actual_start_datetime || null;
  const estimatedTime =
    location?.estimated_departure_date_time_with_tz || location?.estimated_arrival_date_time_with_tz || null;
  let signatureObject =
    location?.documents?.find((doc) => doc.image_type === "signature") || null;
  const appointment = location?.appointment ? { ...location.appointment } : {};
  const hasDateTime = !!appointment?.appt_date;
 
  const driverIn = location?.driver_details?.driver_in_datetime || null;
  const driverOut = location?.driver_details?.driver_out_datetime|| null;
  
  const renderCheckinDetails = () => {
    const isSameDay = driverIn && driverOut ? 
    moment(driverIn)?.format("YYYY-MM-DD") === moment(driverOut)?.format("YYYY-MM-DD"): false;
    return(<>
    {isSameDay ? (
      <Row type="flex">
         <Col style={{ paddingRight: "2px" }}>
         {I18n.t("check_ins.check_in_out")}: &nbsp;
          </Col>
        <Col style={{ fontWeight: "600" }}>
        <DisplayTime
                dateTimeString={driverIn}
                timeFormat={AppConfig.dateTimeFormat}
                displayWithDate={true}
                isUTC={true}
              /> -  <DisplayTime
              dateTimeString={driverOut}
              timeFormat={AppConfig?.time_format}
              displayWithDate={false}
              isUTC={true}
            />
        </Col>
      </Row>
    ) : (
      <>
      <Row type="flex">
          <Col style={{ paddingRight: "12px" }}>
            {I18n.t("check_ins.check_in_out")}: &nbsp;
          </Col>
          <Col style={{ fontWeight: "600" }}>
            {
              (driverIn || driverOut) ?
            <>
            {driverIn ? (
              <DisplayTime
                dateTimeString={driverIn}
                timeFormat={AppConfig.dateTimeFormat}
                displayWithDate={true}
                isUTC={true}
              />
            ) : "NA"}
            {" - "}
            {driverOut ? (
              <DisplayTime
                dateTimeString={driverOut}
                timeFormat={AppConfig.dateTimeFormat}
                displayWithDate={true}
                isUTC={true}
              />
            ) : 'NA'}
            </> : "NA"}
          </Col>
        </Row>
       
      </>
    )}
  </>)

  }
  const renderFile = () => {
    const fileType = getFileType(signatureObject?.src || signatureObject?.picture_url);
    return (
      <>
      {fileType === "image" ? (
        <img
          className="signature-image"
          src={signatureObject?.src || signatureObject?.picture_url}
          alt=""
        />
        ) : (
          <Icon
            type={getFileIcon(fileType)}
            style={{
              fontSize: "48px",
              color: "#576EC1",
              cursor: "pointer",
              width: "100%",
              height: "100%",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              opacity: 0.35,
            }}
          />
        )}
      </>
    )
  }
   // This function calls from parent component
   const Updateloscode = async (event, field, header, verify) => {
    
    renderTitleAddressDetails(field, header);
    positionEditModal(event, field);
    setVerifyLosFromScreen(verify);
  };

  // This use-effect is used for getting function from parent component
  useEffect(() => {
    if (commonLos) {
      commonLos({ Updateloscode });
    }
  }, [commonLos, refreshDetails]);


  let cdkAppointment = null;
  if (location?.actual_start_datetime && location?.actual_end_datetime) {
    const appt_date  = location.actual_start_datetime.split(" ")[0];
    const start_time = location.actual_start_datetime.split(" ")[1].substring(0, 5);
    const end_time   = location.actual_end_datetime.split(" ")[1].substring(0, 5);
  
    cdkAppointment = {
      slots: [`${start_time}-${end_time}`],
      appt_date,
      start_time,
      end_time,
    };
  }
  const hasCDKDateTime = !isEmpty(cdkAppointment) && cdkAppointment?.appt_date;
  const cdkCondition = currentOrder?.customer_order_details?.order_label === "CDK"  || currentOrder?.customer_order_details?.order_label === "WO"
  const cdkLocationCondition = location?.location_label === "CDK"
  const hideNonCDK = cdkCondition ? true : cdkLocationCondition ? true : false

  const isCrossDock = location?.label_code === "CDK" || orderTypeConfig.code === 'CDK' || orderTypeConfig.code === 'WO';

  const losText = location?.los_name || location?.los_code || emptyText

  return (
    <div className="address-location-section">
      {" "}
      {/* style={{ width: "440px" }} */}
      {location?.id ? (
        <SectionCard
          title={title}
          extraActionNode={extranodeFunc()}
          maximumHeight={maximumHeight}
        >
          <DisableWrapper
            disabled={disableEditLHOrder}
            opacity={1}
            className={disableEditLHOrder ? "address-location-lh-readonly" : undefined}
          >
          <AddressLocationCard
            location={location}
            orderTypeConfig={orderTypeConfig}
            emptyText={emptyText}
            isCrossDock={isCrossDock}
            showActions={showActions}
            renderTitleAddressDetails={renderTitleAddressDetails}
            positionEditModal={positionEditModal}
            setIsAddressFormScreen={setIsAddressFormScreen}
            orgSettings={orgSettings}
            config={config}
            configLoading={configLoading}
            isImportOrder={isImportOrder}
          />

          {/* <Row className="address-location-card" type="flex" gutter={[16, 16]}>
            <Col xs={24} xl={8} className="image-container">
            
              <div className="image-wrapper">
                <div className="location-image">
                   <AddressLocationMap location={location} orderTypeConfig={orderTypeConfig}/>
                </div>
              </div>
            </Col>
            <Col xs={24} xl={16} className="address-container">
              <Row gutter={[8, 8]} className="address-container-row">
                <Col className="address-location-name">
                  <span className="address">
                    {location?.first_name ? formatFullName(location) : ""}
                    {location?.company_name
                      ? `(${location?.company_name})`
                      : ""}
                  </span>
                  <br />
                  <span className="address-location">
                    {location?.address ? (
                      <AddressInfo address={location.address} />
                    ) : (
                      emptyText
                    )}
                  </span>
                </Col>
                <Col className="address-location-details">
                  <Row>
                    <Col
                      lg={12}
                      xs={24}
                      style={{ display: "flex", gap: "5px" }}
                    >
                      <img src={CommercialIcon} alt="" />
                      <span className="details-text">
                        {location?.address_type || emptyText}
                      </span>
                    </Col>
                    <Col
                      lg={12}
                      xs={24}
                      style={{ display: "flex", gap: "5px" }}
                    >
                      <img src={MailIcon} alt="" />
                      <span
                        className="details-text"
                        style={{ overflow: "hidden", textOverflow: "ellipsis" }}
                      >
                        <Tooltip
                          title={location?.email || ""}
                          overlayClassName="account-view-tooltip"
                        >
                          {location?.email || emptyText}
                        </Tooltip>
                      </span>
                    </Col>
                  </Row>
                  <Row>
                    <Col
                      lg={12}
                      xs={24}
                      style={{ display: "flex", gap: "5px" }}
                    >
                      <img src={PhoneIcon} alt="" />
                      <span className="details-text">
                        {location?.phone ? (location.phone.startsWith('+') ? location.phone : `+${location.phone}`) : emptyText}
                      </span>
                    </Col>
                    <Col
                      lg={12}
                      xs={24}
                      style={{ display: "flex", gap: "5px" }}
                    >
                      <img src={PhoneIcon} alt="" />
                      <span className="details-text">
                        {location?.phone_2 ? (location.phone_2.startsWith('+') ? location.phone_2 : `+${location.phone_2}`) : emptyText}
                      </span>
                    </Col>
                  </Row>
                </Col>
              </Row>
              {showActions && (
                // <Col className="address-location-edit" xl={2}>
                <img
                  className="address-location-edit"
                  src={EditIcon}
                  alt=""
                  onClick={(event) => {
                    renderTitleAddressDetails(
                      "addressDetails",
                      "Address Details",
                      true
                    );
                    positionEditModal(event, "addressDetails");
                    setIsAddressFormScreen(true);
                  }}
                />
                // </Col>
              )}
            </Col>
          </Row> */}
          
          <div className="address-location-details-los">
            <Row className="address-location-los">
              {/* <Row>
              <span>Location Code</span>
            </Row> */}
            </Row>
          </div>
          {orderTypeConfig.code === "MS" && (
                   <div>
                      <Row gutter={[8, 8]} className="address-location-details-los">
              <Col lg={6}>
                <Row className="address-location-los" data-testid="total-weight-view">
                  <Col span={20}>
                    <span className="details-heading">Total Weight</span>
                    <br />
                    <span className="details-data location-code">
                    {location?.weight 
                    ? `${location.weight} lbs / ${convertToKg(location.weight)} kg`
                    : emptyText} 
                  <span className="details-data-unit"></span>
                    </span>
                  </Col>
                {showActions && location?.id && (
                  <Col span={4} className="edit-los-icon">
                    <img
                      data-testid="edit-weight"
                      src={EditIcon}
                      alt=""
                      onClick={(event) => {
                        renderTitleAddressDetails("weight", "Weight");
                        positionEditModal(event, "weight");
                      }}
                    />
                  </Col>
                )}
              </Row>
            </Col>
            <Col lg={6}>
              <Row className="address-location-los" data-testid="quantity-view">
                <Col span={20}>
                  <span className="details-heading">Quantity</span>
                  <br />
                  <span className="details-data location-code">
                    {location?.quantity || emptyText}
                  </span>
                </Col>
                {showActions && location?.id && (
                  <Col span={4} className="edit-los-icon">
                    <img
                      data-testid="edit-quantity"
                      src={EditIcon}
                      alt=""
                      onClick={(event) => {
                        renderTitleAddressDetails("quantity", "Quantity");
                        positionEditModal(event, "quantity");
                      }}
                    />
                  </Col>
                )}
              </Row>
            </Col>
            <Col lg={6}>
              <Row className="address-location-los" data-testid="skids-pallets-view">
                <Col span={20}>
                  <span className="details-heading">Skids/Pallets</span>
                  <br />
                  <span className="details-data location-code">
                    {location?.pallets || emptyText}
                  </span>
                </Col>
                {showActions && location?.id && (
                  <Col span={4} className="edit-los-icon">
                    <img
                      data-testid="pallets-edit"
                      src={EditIcon}
                      alt=""
                      onClick={(event) => {
                        renderTitleAddressDetails("pallets", "Skids/Pallets");
                        positionEditModal(event, "pallets");
                      }}
                    />
                  </Col>
                )}
              </Row>
            </Col>
            <Col lg={6}>
              <Row className="address-location-los" data-testid="surface-area-view">
                <Col span={20}>
                  <span className="details-heading">Surface Area</span>
                  <br />
                  <span className="details-data location-code">
                    {location?.surface_area || emptyText} <span className="details-data-unit">in²</span>
                  </span>
                </Col>
                {showActions && location?.id && (
                  <Col span={4} className="edit-los-icon">
                    <img
                      data-testid="surface-area-edit"
                      src={EditIcon}
                      alt=""
                      onClick={(event) => {
                        renderTitleAddressDetails("surface_area", "SurfaceArea");
                        positionEditModal(event, "surface_area");
                      }}
                    />
                  </Col>
                )}
              </Row>
            </Col>
          </Row>
            </div>
        )}
          <Row
            gutter={[8, 8]}
            // style={{ paddingTop: "10px" }}
            className="address-location-details-los"
          >
              <Col lg={6}>
              <Row type="flex" align="middle" justify="space-between">
                <Col>
                  <span className="details-heading">Location Code</span>
                  <br />
                  <span className="details-data location-code">
                    {location?.acc_loc_code || emptyText}
                  </span>
                </Col>
                {showActions && location?.id && (
                  <Col span={2} className="edit-los-icon">
                    <img
                      src={EditIcon}
                      alt=""
                      onClick={(event) => {
                        if (location?.address?.address_line1?.length > 0) {
                          renderTitleAddressDetails(
                            "locationCode",
                            "Location Code"
                          );
                          positionEditModal(event, "locationCode");
                        } else {
                          renderTitleAddressDetails(
                            "addressDetails",
                            "Address Details",
                            true
                          );
                          positionEditModal(event, "addressDetails");
                          setIsAddressFormScreen(true);
                        }
                      }}
                    />
                  </Col>
                )}
              </Row>
            </Col>
            {(orgSettings?.individual_stop_los_order_level == "true" || orderTypeConfig.code !== 'MS') && <Col lg={6}>
              <Row className="address-location-los">
                <Col span={20}>
                  <span className="details-heading">{I18n.t("general.level_of_service")}</span>
                  <br />
                  <span className="details-data location-code">
                    <Tooltip title={losText}>
                      <span
                        style={{
                          display: "inline-block",
                          maxWidth: 100, // adjust as needed
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          whiteSpace: "nowrap",
                          verticalAlign: "bottom",
                        }}
                      >
                        {losText}
                      </span>
                    </Tooltip>
                  </span>
                </Col>
                {showActions && location?.id && !losEditLockedView && (
                  <Col span={4} className="edit-los-icon">
                    <img
                      data-testid="los-edit"
                      src={EditIcon}
                      alt=""
                      onClick={(event) => {
                        renderTitleAddressDetails(
                          "levelOfService",
                          I18n.t("general.level_of_service")
                        );
                        positionEditModal(event, "levelOfService");
                        setVerifyLosFromScreen(true);
                      }}
                    />
                  </Col>
                )}
              </Row>
            </Col>}
            <Col lg={4}>
              <Row className="address-location-los" data-testid="duration-view">
                <Col span={20}>
                  <span className="details-heading">Duration</span>
                  <br />
                  <span className="details-data location-code">
                    {location?.service_duration || emptyText}{" "}
                    <span className="details-data-unit">{location?.service_duration ? "Min" : ''}</span>
                  </span>
                </Col>
                {showActions && location?.id && (
                  <Col span={4} className="edit-los-icon">
                    <img
                      data-testid="duration-edit"
                      src={EditIcon}
                      alt=""
                      onClick={(event) => {
                        renderTitleAddressDetails("duration", "Duration");
                        positionEditModal(event, "duration");
                      }}
                    />
                  </Col>
                )}
              </Row>
            </Col>
            {!["R", "D", "LH","NLH", "MS", ...moveOrderTypes].includes(orderTypeConfig.code) &&
              <Col lg={4}>
                <Row className="address-location-los" data-testid="miles-view">
                  <Col span={20}>
                    <span className="details-heading">Miles</span>
                    <br />
                    <span className="details-data location-code">
                      {location?.stop_miles !== "NA" ? roundToDecimals(location?.stop_miles, roundOffDecimalsForDistance) : location?.stop_miles ?? ""}{" "}
                    </span>
                  </Col>
                  {showActions && location?.id && (
                    <Col span={4} className="edit-los-icon">
                      <img
                        data-testid="miles-edit"
                        src={EditIcon}
                        alt=""
                        onClick={(event) => {
                          renderTitleAddressDetails("stop_miles", "MilesScreen");
                          positionEditModal(event, "stop_miles");
                        }}
                      />
                    </Col>
                  )}
                </Row>
              </Col>
            }
            <Col lg={4}>
              <span className="details-heading">{`${
                location?.label_name || ""
              } Status`}</span>
              <br />
              {renderLocationStatus()}
            </Col>
          </Row>
          <Card className="received-card-section" style={{ marginTop: "16px" }}>
            <Row>
              {!hideNonCDK && (
                <Col span={24}>
                  {(haveMultipleLocations && location.type_of_loc === "PICKUP") || !haveMultipleLocations ? renderTimeRow("Received", "received", received_at) : 
                  ['RD', 'T', 'OBT', 'RT', 'LH','NLH','PLHD','LHD','PLH'].includes(orderTypeConfig.code) && <div style={{ height : 33 }}></div>}
                  {location.type_of_loc === "PICKUP"
                    ? renderTimeRow("Pickup By", "pickupBy", pickup_by)
                    : location.type_of_loc === "DELIVERY"
                    ? renderTimeRow("Delivery By", "deliveryBy", delivery_by)
                    : null}
                </Col>
              )}
            
              <Col span={24}>
                <Row
                  data-testid="appointment-view"
                  type="flex"
                  className={`key-value-text ${hasDateTime ? "has-date" : ""}`}
                >
                  {(cdkCondition || cdkLocationCondition) && (
                    <Col xs={24} xl={6} className="key-text">
                      {location.type_of_loc === "PICKUP"
                        ? cdkLocationCondition ? "Dropoff By" : "Pick By"
                        : location.type_of_loc === "DELIVERY"
                        ? cdkLocationCondition ? "Pick By" : "Dropoff By"
                        : getLabelForAppointments()}
                    </Col>
                  )}
                  {!hideNonCDK && (
                    <Col xs={24} xl={6} className="key-text">
                      {getLabelForAppointments()}
                    </Col>
                  )}
                  {appointment?.appt_date ? (
                    <>
                      <Col xs={10} xl={8} className="value-Text">
                        {moment
                          .utc(appointment.appt_date)
                          .format(AppConfig.report_date_format) || emptyText}
                      </Col>
                      <Col xs={10} xl={8} className="value-Text">
                        <Row type="flex" gutter={4}>
                          <Col>
                            <DisplayTime
                              displayWithDate={false}
                              dateTimeString={moment.utc(
                                appointment.start_time,
                                "HH:mm"
                              )}
                            />
                          </Col>
                          <Col>-</Col>
                          <Col>
                            <DisplayTime
                              displayWithDate={false}
                              dateTimeString={moment.utc(
                                appointment.end_time,
                                "HH:mm"
                              )}
                            />
                          </Col>
                          <Col>{location.time_zone_short_name}</Col>
                        </Row>
                      </Col>
                    </>
                  ) : (
                    showActions && (
                      <Col span={16} className="value-Text">
                        {location?.id ? (
                          <Button_v2
                            data-testid="add-appintment-button"
                            text={I18n.t("appointments.add")}
                            className="medium-btn flat"
                            onClick={(event) => {
                              renderTitleAddressDetails(
                                "appointment",
                                (cdkCondition || cdkLocationCondition)
                                  ? I18n.t("general.appointment")
                                  : getLabelForAppointments()
                              );
                              positionEditModalWhenNoData(event, "appointment");
                            }}
                          />
                        ) : (
                          emptyText
                        )}
                      </Col>
                    )
                  )}
                  {showActions && location?.id && (
                    <Col span={2} className="edit-icon">
                      <img
                        data-testid="appointment-edit"
                        src={EditIcon}
                        alt=""
                        onClick={(event) => {
                          renderTitleAddressDetails(
                            "appointment",
                            (cdkCondition || cdkLocationCondition)
                              ? I18n.t("general.appointment")
                              : getLabelForAppointments()
                          );
                          positionEditModal(event, "appointment");
                        }}
                      />
                    </Col>
                  )}
                </Row>
              </Col>
             

              {currentPreplan?.delivery_start_date && (
                <Col span={24}>
                  <Row type="flex" align="middle" justify="end">
                    <Col className="appointment-preplan-chip">
                      <PreplanIcon width="12" height="12" color="#576EC1" />
                      <span>
                        Preplan:{" "}
                        <DisplayTime
                          dateTimeString={currentPreplan.delivery_start_date}
                          displayWithDate={true}
                          timeFormat={AppConfig.dateFormat}
                          timeZoneId={currentPreplan.timeZoneId}
                        />{" "}
                        -{" "}
                        <DisplayTime
                          dateTimeString={currentPreplan.delivery_end_date}
                          displayWithDate={true}
                          timeFormat={AppConfig.dateFormat}
                          timeZoneId={currentPreplan.timeZoneId}
                        />
                      </span>
                      <ChevronRightIcon
                        width="12"
                        height="12"
                        color="#576EC1"
                      />
                    </Col>
                  </Row>
                </Col>
              )}
               {(cdkCondition || cdkLocationCondition) && (
                <Col span={24}>
                  {location.type_of_loc === "PICKUP"
                    ? renderTimeRow(cdkLocationCondition ? "Received" : "Picked Up", "pickedUp", cdk_actual_times)
                    : location.type_of_loc === "DELIVERY"
                    ? renderTimeRow(
                        cdkLocationCondition ? "Picked Up" : "Received" ,
                        "receivedCdk",
                        cdk_actual_times
                      )
                    : null}
                </Col>
              )}
              {!hideNonCDK && (
                <Col span={24}>
                  {renderTimeRow("ETA", "etaDetails", estimatedTime)}
                  {renderTimeRow("Actual", "actual", actual_at)}
                  {showLtlOnHandFields(currentOrg, orderTypeConfig?.code || currentOrder?.type_of_order) &&
                    ["PICKUP", "DELIVERY"].includes(location?.type_of_loc) &&
                    renderTimeRow(
                      location.type_of_loc === "PICKUP"
                        ? I18n.t("general.on_hand_at_origin")
                        : I18n.t("general.on_hand_at_destination"),
                      "onHand",
                      location?.on_hand_datetime
                    )}
                  {isLtlOrganization(currentOrg) &&
                    ["PLH", "NLH"].includes(orderLabel) &&
                    location?.type_of_loc === "DELIVERY" &&
                    (orderWarehouseMatchesDelivery || location?.outbound_dock_datetime) &&
                    renderTimeRow(
                      I18n.t("general.outbound_dock_time"),
                      "outboundDock",
                      location?.outbound_dock_datetime
                    )}
                  {/* {renderCheckinDetails()} */}
                </Col>
              )}
            </Row>
          </Card>
          </DisableWrapper>
          <Card
            data-testid="signature-section-view"
            className={`signature-card-section ${
              signatureObject ? "has-signature" : ""
            }`}
            style={{ marginTop: "16px" }}
          >
            <Row
              className="signature-details"
              type="flex"
              align="middle"
              justify="space-between"
            >
              <Col xs={24} sm={24} xl={12} style={{ minHeight: 24 }}>
                <span className="signature-details-heading">
                  {signatureObject ? (
                    <Fragment>
                      {signatureObject.sign_by || ""}&nbsp;
                      {signatureObject.title_by_relation
                        ? `, ${signatureObject.title_by_relation}`
                        : ""}
                    </Fragment>
                  ) : (
                    "Signature Required"
                  )}
                </span>
                <br />

                {signatureObject?.captured_at && (
                  <span className="signature-details-date">
                    <Fragment>
                      {moment
                        .utc(signatureObject.captured_at)
                        .format(AppConfig.report_date_format)}{" "}
                      at
                      {" "}
                      {
                        <DisplayTime
                          displayWithDate={false}
                          dateTimeString={signatureObject.captured_at}
                        />
                      }{" "}
                      {location.time_zone_short_name}
                    </Fragment>{" "}
                  </span>
                )}
              </Col>
              {signatureObject ? (
                <Fragment>
                  <Col xs={20} sm={20} xl={10}>
                    {signatureObject?.src || signatureObject?.picture_url ? renderFile() : ''}
                    {/* {signatureObject?.picture_url ? (
                      <img
                        className="signature-image"
                        src={signatureObject.picture_url}
                        alt=""
                      />
                    ) : (
                      ""
                    )} */}
                  </Col>
                  {showActions && (
                    <Col span={2} className="signature-edit-icon">
                      <img
                        data-testid="signature-edit"
                        src={EditIcon}
                        alt=""
                        onClick={() => openModal(true)}
                      />
                    </Col>
                  )}
                </Fragment>
              ) : (
                showActions && (
                  <Col
                    xs={24}
                    sm={24}
                    xl={7}
                    className="signature-upload-button fontSize14"
                  >
                    <Button_v2
                      data-testid="add-signature-button"
                      onClick={() => openModal(true)}
                      className="flat small-btn"
                      text="Add Signature"
                    />
                  </Col>
                )
              )}
            </Row>
          </Card>
          <Row gutter={16} style={{ marginTop: "16px"}}>
            <Col span={12}>
              <OrderForm
                isFormFilled={locObj?.is_form_submitted || false}
                currentOrder={currentOrder}
                location={locObj}
              />
            </Col>
            <Col span={12}>
              <OrderSurveyDetails
                isFormFilled={locObj?.is_survey_submitted || false}
                currentOrder={currentOrder}
                location={locObj}
              />
            </Col>
          </Row>
        </SectionCard>
      ) : (
        <SectionCard
          title={title}
          // extraActionNode={extranodeFuncForNoData()}
          maximumHeight={"576px"}
        >
          <div style={{display: "flex", flexDirection: "column", alignItems: "center"}}>
            {/* <img src="" alt="" /> */}
            <div>
                  {getOrderTypeIconForLocationMap(generateOrderCombinedCode(), {
                    height: "128",
                    width: "128",
                  })}
            </div>
            <p className="no-data">{titleEmptyCard} details not yet provided.</p>
            {!locked && <Button_v2
              data-testid="add-details-button"
              text={"Add Details"}
              className="medium-btn flat"
              onClick={(event) => {
                renderTitleAddressDetails(
                  "addressLocation",
                  "Address Location",
                  true
                );
                positionEditModal(event, "addressLocation");
              }}
            />}
          </div>
        </SectionCard>
      )}
      {isModalOpen && renderSignatureForm()}
      {openAddressCredsModal && renderAddressCredsModal()}
      {renderStatusChangeModal()}
      {revokeEmailStage && (
        <TenderEmailModal
          key={`revoke-${(revokeEmailStage.agentEmails || []).map((a) => a.agent_id).join(",")}`}
          visible
          mode="revoke"
          orgId={currentOrg.id}
          agentEmails={revokeEmailStage.agentEmails}
          revokeOrders={revokeEmailStage.revokeOrders}
          onBack={() => setRevokeEmailStage(null)}
          onDone={() => {
            setRevokeEmailStage(null);
            if (refreshDetails) refreshDetails();
          }}
        />
      )}
    </div>
  );
}

AddressLocationsView.propTypes = {
  currentPreplan: PropTypes.shape(),
  orgSettings: PropTypes.shape(),
  setOutofPreplan: PropTypes.func,
  setIsModified: PropTypes.func,
  currentRoute: PropTypes.shape(),
};
AddressLocationsView.defaultProps = {
  currentPreplan: {},
  orgSettings: {},
  setOutofPreplan: () => {},
  setIsModified: () => {},
  currentRoute: {},
};

export default Form.create()(AddressLocationsView);
